import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// import '../styles/modal.css';


import { getAllAnwers, getAnhelosBeneficios, getAllEneaBeneficios, getAllInterestedActor } from '../actions/actions';
import { buildPercentAnhelo, buildImpactInterst } from '../constantsGlobal'

import ContentMetricTriggerPerson from '../components/contentMetricTriggerPerson';

import { personalInterst } from '../resources/resources'



class Interest extends Component {
    

    componentWillMount() {
        const { actor, history } = this.props;

        if (!actor.id) {
            history.push("/");
        }

        // getAllEneaBeneficios();
        // getAllAnwers(actor.id);
        // getAllInterestedActor(actor.id);
        // getAnhelosBeneficios();
    }


    render() {
        const { actor, allAnswers, anhelosBeneficios, anhelos, allInterests } = this.props;

        let _anhelos = buildPercentAnhelo(allAnswers, anhelosBeneficios, actor, anhelos);

        // let topBeneficios = buildTopBeneficios(_anhelos, allAnswers, actor, eneaBeneficios, anhelosBeneficios);
        // topBeneficios = topBeneficios.map(item => ({ ...item, text: item.beneficio, value: Math.round(item.valor) }));

        
        let impact = buildImpactInterst(allInterests, personalInterst, _anhelos);


        return (
            <section className="main-content" >

                <div className="section-main">
                <ContentMetricTriggerPerson motivadores={impact} anhelosInfo={_anhelos} />
                </div>


            </section>
        );
    }
}

const mapStateToProps = state => ({
    actor: state.diagnosis.actor,
    questios: state.diagnosis.questios,
    answers: state.diagnosis.answers,
    anhelos: state.diagnosis.anhelos,
    allAnswers: state.diagnosis.allAnswers,
    eneaBeneficios: state.diagnosis.eneaBeneficios,
    anhelosBeneficios: state.diagnosis.anhelosBeneficios,
    allInterests: state.diagnosis.allInterests
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAllAnwers,
        getAnhelosBeneficios,
        getAllEneaBeneficios,
        getAllInterestedActor
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(Interest);
